import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ContentDraftItem} from '../../../contentFeeds.types';

interface ContentFeedDraftItemsState {
  items: ContentDraftItem[];
  isLoading: boolean;
  error: string | null;
  loadedFeedId: number | null;
}

const contentFeedDraftItemsInitialState: ContentFeedDraftItemsState = {
  items: [],
  isLoading: false,
  error: null,
  loadedFeedId: null,
};

const contentFeedDraftItemsSlice = createSlice({
  name: 'draftItems',
  initialState: contentFeedDraftItemsInitialState,
  reducers: {
    setDraftItems: (state, action: PayloadAction<ContentDraftItem[]>) => {
      state.items = action.payload;
    },
    addDraftItem: (state, action: PayloadAction<ContentDraftItem>) => {
      state.items.push(action.payload);
    },
    updateDraftItemInStore: (state, action: PayloadAction<ContentDraftItem>) => {
      const index = state.items.findIndex((item) => item.id === action.payload.id);

      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeDraftItem: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    setDraftItemsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setDraftItemsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setLoadedDraftItemsFeedId: (state, action: PayloadAction<number | null>) => {
      state.loadedFeedId = action.payload;
    },
    resetDraftItems: () => contentFeedDraftItemsInitialState,
  },
});

export default contentFeedDraftItemsSlice.reducer;

export const {
  setDraftItems,
  addDraftItem,
  updateDraftItemInStore,
  removeDraftItem,
  setDraftItemsLoading,
  setDraftItemsError,
  setLoadedDraftItemsFeedId,
  resetDraftItems,
} = contentFeedDraftItemsSlice.actions;
